import { useCallback, useContext, useState } from 'react';
import { Button } from '@alf/uikit';
import { useGeneralRoutes } from '@namespace/cms';
import { REDIRECT_PARAM } from '@namespace/common';
import { useI18n } from '@namespace/i18n';
import { useNotifications } from '@namespace/notifications';
import { useHistory } from '@namespace/router';
import { USER_ROLES, UserContext } from '@namespace/user';
import { addBonusParticipant } from '../../api/addBonusParticipant';
import { DEFAULT_ACTIVE_TAG } from '../../constants';
import { promotionsActions } from '../../store';

export const BonusTakePartButton = ({
  bonusSource,
  bonusTemplateId,
  onSuccessTakePart,
  isDisable
}) => {
  const { FETCH_PROMOTIONS } = promotionsActions;
  const [user] = useContext(UserContext);
  const { push } = useHistory();
  const { t } = useI18n();
  const { login, promotions } = useGeneralRoutes();
  const redirectLink = `${promotions}/bonuses/${DEFAULT_ACTIVE_TAG}`;
  const bonusLoginLink = `${login}?${REDIRECT_PARAM}${redirectLink}`;
  const isLoggedInUser = user?.role === USER_ROLES.USER;
  const { errorNotification, successNotification } = useNotifications();

  const [isJoinBonusInProcess, setIsJoinBonusInProcess] = useState(false);

  const handleTakePartClick = useCallback(
    async (event) => {
      try {
        event.stopPropagation();

        if (!isLoggedInUser) {
          push(bonusLoginLink);

          return;
        }

        setIsJoinBonusInProcess(true);

        const { status, errorCode, data } = await addBonusParticipant({
          bonusTemplateId,
          bonusSource
        });
        const { bonusInstanceId } = data;

        if (status === 'success') {
          successNotification(t('web.bonuses.userparticipation.success'));
          onSuccessTakePart(bonusSource === 'bs' ? bonusInstanceId : '');
        } else {
          throw new Error(errorCode);
        }

        setIsJoinBonusInProcess(false);
      } catch {
        setIsJoinBonusInProcess(false);
        errorNotification(t(`web.bonuses.userparticipation.error`));
      }
    },
    [
      isLoggedInUser,
      bonusTemplateId,
      push,
      bonusLoginLink,
      successNotification,
      t,
      errorNotification,
      FETCH_PROMOTIONS,
      onSuccessTakePart,
      bonusSource
    ]
  );

  return (
    <Button
      intent="primary"
      size="m"
      actionType="color1"
      fullWidth={true}
      onClick={handleTakePartClick}
      processing={isJoinBonusInProcess}
      data-role="promo-bonus-item-take-part-btn"
      disabled={isDisable}
    >
      {t('web.bonuses.button.takepart')}
    </Button>
  );
};
